import React, { useState } from "react";
import { formatBook } from "../../../utils/formatOdds";
import Collapse from "../../../components/Collapse";
import CasinoTableLayout from "../../casinoComponents/casinoTableLayout";
import { formatRangeVal, lucky7Markets } from "../../casinoComponents/betTableLucky7/lucky7Utils";
import Lucky7RefResults from "../resultui/resultLucky7/Lucky7RefResults";
import VCasinoVideo from "./VCasinoVideo";
import VCasinoRightSide from "./VCasinoRightSide";

const IMG = `${import.meta.env.BASE_URL}img/cards`;
const SUIT = `${import.meta.env.BASE_URL}assets/img/icons`;
const CARD_VALUES = ["A", "2", "3", "4", "5", "6", "7", "8", "9", "10", "J", "Q", "K"];

const isSuspended = (b) => String(b?.gstatus || "").toUpperCase() !== "OPEN";
const odds = (b) => (b?.b !== undefined && b?.b !== null && b?.b !== "" ? b.b : 0);

/**
 * Virtual Lucky 7 (vcasino/lucky7, API type vlucky7) in the reference markup:
 *   .casino-table.vcasino.vlucky7 > [.progress.mobile-timer] + .casino-video (title, card, icons)
 *     + .casino-detail > .main-odds (Low / High) + .other-odds (Even, Odd, Black, Red, 4 lines, 13 cards)
 *     + .casino-video-last-results
 *   right sidebar: My Bets (UserName / Rate / Amount).
 */
export default function VLucky7View({ gameName, title, data, exposures = {}, onBetClick, myBets, onViewMore, viewMoreModal }) {
  const [openRange, setOpenRange] = useState(null);
  const m = lucky7Markets(data?.sub);
  const getExposure = (name) => {
    const v = exposures[name] ?? exposures[name?.toLowerCase?.()];
    return v != null ? Number(v) || 0 : 0;
  };
  const bookCls = (b) => (getExposure(b?.nat) > 0 ? "book-green" : "book-red");
  const click = (b) => {
    if (isSuspended(b)) return;
    onBetClick?.(odds(b), b?.nat, null, b);
  };
  // Reference book directive adds .lock-top to a suspended parent of the book element
  const suspLock = (b) => (isSuspended(b) ? " suspended lock-top" : "");

  const lhBox = (cls, b) => (
    <div className={`${cls} lh-box${suspLock(b)}`} onClick={() => click(b)}>
      <div>
        <div className="dt-name">{b?.nat}</div> <div className="dt-odds">{odds(b)}</div>
      </div>{" "}
      <div className={`dt-book w-100 ${bookCls(b)}`}>{formatBook(getExposure(b?.nat))}</div>
    </div>
  );

  const evenBox = (n, b, name) => {
    const id = `demo${n}`;
    return (
      <div className={`even-box back-box${suspLock(b)}`} onClick={() => click(b)}>
        <div>
          <div className="dt-name">{name}</div> <div className="dt-odds">{odds(b)}</div>
        </div>{" "}
        <div className={`dt-book ${bookCls(b)}`}>{formatBook(getExposure(b?.nat))}</div>{" "}
        <div className="v-min-max">
          <i
            data-toggle="collapse"
            data-target={`#${id}`}
            className="fas fa-info-circle"
            onClick={(e) => {
              e.stopPropagation();
              setOpenRange((p) => (p === id ? null : id));
            }}
          />{" "}
          <Collapse id={id} open={openRange === id} className="icon-range">
            {"\n                                        R:"}
            <span>{formatRangeVal(b?.min)}</span>-<span>{formatRangeVal(b?.max)}</span>
          </Collapse>
        </div>
      </div>
    );
  };

  const imgs = (srcs) => (
    <>
      {srcs.map((src, i) => (
        <React.Fragment key={src}>
          {i > 0 && " "}
          <img src={src} alt="" />
        </React.Fragment>
      ))}
    </>
  );
  const single = (vals) => imgs(vals.map((v) => `${IMG}/single/${v}.jpg`));

  return (
    <CasinoTableLayout tableClass="vcasino vlucky7" rightSide={<VCasinoRightSide bets={myBets} onViewMore={onViewMore} />}>
      <>
        <VCasinoVideo gameType={gameName} title={title} data={data} cardLabel="Card" />{" "}
        {data?.mid ? (
          <div className="casino-detail">
            <div className="main-odds">
              {lhBox("low-box", m[0])} {lhBox("high-box", m[1])}{" "}
              <div className="w-100 text-right mt-4">
                R:<span>{formatRangeVal(m[0]?.min)}</span>-<span>{formatRangeVal(m[0]?.max)}</span>
              </div>
            </div>{" "}
            <div className="other-odds">
              {evenBox(2, m[2], m[2]?.nat)} {evenBox(3, m[3], m[3]?.nat)}{" "}
              {evenBox(5, m[5], imgs([`${SUIT}/spade.png`, `${SUIT}/club.png`]))}{" "}
              {evenBox(4, m[4], imgs([`${SUIT}/heart.png`, `${SUIT}/diamond.png`]))}{" "}
              {evenBox(19, m[19], single(["A", "2", "3"]))} {evenBox(20, m[20], single(["4", "5", "6"]))}{" "}
              {evenBox(21, m[21], single(["8", "9", "10"]))} {evenBox(22, m[22], single(["J", "Q", "K"]))}{" "}
              <div className="vcasino-card-box-top">
                <div className="w-100 vcasino-card-bhav text-center">{odds(m[6])}</div>{" "}
                {CARD_VALUES.map((v, i) => {
                  const b = m[6 + i];
                  return (
                    <div key={v} className="vcasino-card-box">
                      <div className={`d-inline-block${isSuspended(b) ? " suspended" : ""}`} onClick={() => click(b)}>
                        <img src={`${IMG}/${v}.png`} alt="" />
                      </div>{" "}
                      <div className={bookCls(b)}>{formatBook(getExposure(b?.nat))}</div>
                    </div>
                  );
                })}{" "}
                <div className="w-100 text-right mt-4">
                  R:<span>{formatRangeVal(m[6]?.min)}</span>-<span>{formatRangeVal(m[6]?.max)}</span>
                </div>
              </div>
            </div>{" "}
            {data?.remark ? (
              <div className="casino-remark mt-3">
                <div className="remark-icon">
                  <img src={`${import.meta.env.BASE_URL}assets/img/icons/remark.png`} alt="" />
                </div>{" "}
                <marquee>{data.remark}</marquee>
              </div>
            ) : null}{" "}
            <div className="casino-video-last-results">
              <Lucky7RefResults gameType={gameName} variant="lucky7" fallbackTitle={title} />
            </div>
          </div>
        ) : null}
      </>
      {viewMoreModal}
    </CasinoTableLayout>
  );
}
